var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from '~/core/decorator';
import { FilterService } from '~/utils/filter.service';
var CaseAssitCaseService = /** @class */ (function () {
    function CaseAssitCaseService() {
    }
    /**
     * 协催管理-诉讼案件
     */
    CaseAssitCaseService.prototype.queryCaseAssistlist = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseAssistCasecontroller.queryCaseAssistlist,
            data: {
                caseNumber: data.caseNumber,
                personalName: data.personalName,
                mobileNo: data.mobileNo,
                idCard: data.idCard,
                areaId: data.areaId,
                addressDetail: data.addressDetail,
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueDaysMax: data.overdueDays ? data.overdueDays.max : '',
                overdueDaysMin: data.overdueDays ? data.overdueDays.min : '',
                turnSource: data.turnSource,
                productCategory: data.productCategory,
                followInTimeMin: FilterService.dateRanageFormat(data.creatTime).start,
                followInTimeMax: FilterService.dateRanageFormat(data.creatTime).end,
                productName: data.productName,
                lawNumber: data.lawNumber,
                customerCategory: data.customerCategory,
                overduePeriod: data.overduePeriod,
                lawerStatus: data.lawerStatus,
                labelName: data.labelName
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 协催管理-协催管理-重新分案
     */
    CaseAssitCaseService.prototype.confirmDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.caseAssistCasecontroller.newDistributeCaseAssist,
            data: data,
        });
    };
    /**
     * 协催管理-外访待分配-预览
     */
    CaseAssitCaseService.prototype.previewCaseAssist = function (data) {
        return this.netService.send({
            server: domainService.caseAssistCasecontroller.previewCaseAssist,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseAssitCaseService.prototype, "netService", void 0);
    return CaseAssitCaseService;
}());
export { CaseAssitCaseService };
